export const getFloat = (v: string) => +(v || '').replace(',', '.');
